import {ApplicationConfig, ErrorHandler, inject, Injectable} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {ConfirmationService, MessageService} from 'primeng/api';
import {routes} from './app.routes';
import {authInterceptor} from './auth.interceptor';
import {errorInterceptor} from './error.interceptor';
import {AdminV2Theme} from './theme';
import {environment} from './environments/environment';
import {BASE_PATH} from './api-client/variables';

@Injectable({providedIn: 'root'})
export class GlobalErrorHandler implements ErrorHandler {
  private readonly messageService = inject(MessageService);

  handleError(error: unknown): void {
    console.error('An error occurred:', error);
    if (error instanceof Error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.message,
        life: 5000,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An unexpected error occurred.',
        life: 5000,
      });
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: BASE_PATH, useValue: environment.apiUrl},
    providePrimeNG({
      theme: {
        preset: AdminV2Theme,
        options: {
          darkModeSelector: false,
          darkMode: false,
        },
      },
    }),
  ],
};
